// extracted by mini-css-extract-plugin
export default {"column":"mission-column_column__LODD6","status":"mission-column_status__Khf+4","statusIcon":"mission-column_statusIcon__wA+nA","statusText":"mission-column_statusText__Ptqah"};